<script lang="ts">
  import type { PrintSelectionPreviewRow } from "../../../../../../../../_shared/_logic/print-selection-preview"
  import type { LetterOrderReference } from "../../../../../../../../_shared/_logic/letter-table-tags"
  import LetterOrderTag from "../../../../../../_shared/_modules/letter-order-tag"
  let { row }: { row: PrintSelectionPreviewRow } = $props()
  const reference = $derived({
    ...row.selection_row,
    property_label: row.property_label,
    work_order_label: row.order_label,
    order_number: row.order_number ?? row.selection_row?.order_number,
    order_type_internal_label:
      row.order_type_internal_label ?? row.selection_row?.order_type_internal_label,
    unit_label: row.unit_label ?? row.selection_row?.unit_label,
  } as LetterOrderReference)
</script>
<LetterOrderTag row={reference} />
